module.exports = "https://coursera_assets.s3.amazonaws.com/images/94f9613e62d2bb19b288b8d1f1dcdbda.png";